module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-horizontal-67e63e983830aa3639d9de9bef4a8127.svg";